export const COLOR_DISPLAY_GROUP = 'color';
export const SIZE_DISPLAY_GROUP = 'size';
